// extracted by mini-css-extract-plugin
export var background = "styles-module--background--dc3af";